export const WHITE_TEXT = 'whiteText';
export const BACKGROUND2 = 'background2';
export const BLACKBACKGROUND2 = 'blackBackground2';
export const MONETIZATIONDARK1 = 'monetizationDark1';

export const PREMIUM_DEALER_BACKGROUND = 'premiumDealerBackground';
